module.exports = __webpack_public_path__ + "img/background016.487d96dc.jpg";